module.exports = __webpack_public_path__ + "img/pencil-02.a8e80101.svg";